import { styled } from "styled-components";

export const ContainerBox = styled.div`
  max-width: 100%;
`;
